module.exports = __webpack_public_path__ + "static/media/1squared_small.f3c1ae79.jpg";